import React, { Fragment } from 'react'

import ControlBar from './ControlBar'
import MultiRowsActions from './table/MultiRowsActions'
import MultiSelectHandler from '../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import UsersLoader from './_load/UsersLoader'
import UsersTable from './table/UsersTable'

const PageContent = () => {
  return (
    <Fragment>
      <ControlBar />

      <MultiSelectHandler>
        <UsersLoader uncontrolledChildren={<MultiRowsActions />}>
          <UsersTable />
        </UsersLoader>
      </MultiSelectHandler>
    </Fragment>
  )
}

export default PageContent
